import {
  AuditOutlined,
  CarOutlined,
  ControlOutlined,
  CommentOutlined,
  FileTextOutlined,
  GiftOutlined,
  MailOutlined,
  PictureOutlined,
  SettingOutlined,
  StarOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  WalletOutlined,
  AndroidOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { Link, useLocation } from 'react-router-dom';

export const crmMenuItems: MenuProps['items'] = [
  { key: '/', icon: <AuditOutlined />, label: <Link to="/">儀表板</Link> },
  { key: '/live-orders', icon: <ThunderboltOutlined />, label: <Link to="/live-orders">即時柯打</Link> },
  { key: '/topups', icon: <WalletOutlined />, label: <Link to="/topups">積分購買審批</Link> },
  {
    key: '/driver-point-packages',
    icon: <WalletOutlined />,
    label: <Link to="/driver-point-packages">司機積分套餐</Link>,
  },
  { key: '/contact', icon: <MailOutlined />, label: <Link to="/contact">聯絡我們（網頁）</Link> },
  { key: '/privacy-policy', icon: <FileTextOutlined />, label: <Link to="/privacy-policy">私隱政策（網頁）</Link> },
  { key: '/app-terms', icon: <FileTextOutlined />, label: <Link to="/app-terms">App 使用條款</Link> },
  {
    key: '/company-price-notice',
    icon: <FileTextOutlined />,
    label: <Link to="/company-price-notice">公司價告示</Link>,
  },
  { key: '/ride-tips', icon: <FileTextOutlined />, label: <Link to="/ride-tips">搭車秘笈</Link> },
  { key: '/feedbacks', icon: <CommentOutlined />, label: <Link to="/feedbacks">意見反饋</Link> },
  { key: '/news', icon: <SettingOutlined />, label: <Link to="/news">最新消息連結</Link> },
  { key: '/app-share-urls', icon: <SettingOutlined />, label: <Link to="/app-share-urls">App 分享連結</Link> },
  {
    key: '/app-force-update',
    icon: <AndroidOutlined />,
    label: <Link to="/app-force-update">App 強制更新</Link>,
  },
  {
    key: '/passenger-points',
    icon: <GiftOutlined />,
    label: <Link to="/passenger-points">乘客行程積分</Link>,
  },
  {
    key: '/passenger-auto-tip',
    icon: <GiftOutlined />,
    label: <Link to="/passenger-auto-tip">乘客自動貼士</Link>,
  },
  {
    key: '/passenger-nearby-drivers',
    icon: <CarOutlined />,
    label: <Link to="/passenger-nearby-drivers">乘客附近司機範圍</Link>,
  },
  {
    key: '/driver-busy-hours',
    icon: <SettingOutlined />,
    label: <Link to="/driver-busy-hours">司機繁忙時段</Link>,
  },
  {
    key: '/driver-hall-priority',
    icon: <CarOutlined />,
    label: <Link to="/driver-hall-priority">大廳優先秒數</Link>,
  },
  { key: '/messages', icon: <MailOutlined />, label: <Link to="/messages">訊息中心</Link> },
  { key: '/promos', icon: <GiftOutlined />, label: <Link to="/promos">優惠碼</Link> },
  { key: '/ads', icon: <PictureOutlined />, label: <Link to="/ads">廣告管理</Link> },
  { key: '/app-releases', icon: <AndroidOutlined />, label: <Link to="/app-releases">APK 發佈</Link> },
  { key: '/booking-options', icon: <ControlOutlined />, label: <Link to="/booking-options">叫車選項</Link> },
  {
    key: '/scheduled-orders',
    icon: <ControlOutlined />,
    label: <Link to="/scheduled-orders">預約叫車開關</Link>,
  },
  {
    key: '/order-chat-quick-replies',
    icon: <CommentOutlined />,
    label: <Link to="/order-chat-quick-replies">乘客快捷訊息</Link>,
  },
  { key: '/drivers', icon: <CarOutlined />, label: <Link to="/drivers">司機</Link> },
  {
    key: '/driver-live-location',
    icon: <CarOutlined />,
    label: <Link to="/driver-live-location">司機即時位置</Link>,
  },
  { key: '/passengers', icon: <TeamOutlined />, label: <Link to="/passengers">乘客</Link> },
  {
    key: '/order-records/drivers',
    icon: <CarOutlined />,
    label: <Link to="/order-records/drivers">司機接單紀錄</Link>,
  },
  {
    key: '/order-records/passengers',
    icon: <TeamOutlined />,
    label: <Link to="/order-records/passengers">乘客落柯打</Link>,
  },
  { key: '/ratings', icon: <StarOutlined />, label: <Link to="/ratings">評分</Link> },
  { key: '/audit', icon: <AuditOutlined />, label: <Link to="/audit">系統日誌</Link> },
  { key: '/gemini', icon: <SettingOutlined />, label: <Link to="/gemini">Gemini 設定</Link> },
];

type Props = {
  theme?: 'dark' | 'light';
  inlineCollapsed?: boolean;
  onNavigate?: () => void;
};

export default function CrmShellMenu({ theme = 'light', inlineCollapsed, onNavigate }: Props) {
  const loc = useLocation();
  return (
    <Menu
      theme={theme}
      mode="inline"
      selectedKeys={[loc.pathname]}
      items={crmMenuItems}
      inlineCollapsed={inlineCollapsed}
      onClick={onNavigate}
      className="crm-shell-menu"
    />
  );
}
